import React, { useRef, useEffect} from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

import * as style from './PopUpMenu.module.scss';

function PopUpMenu({ 
  handleChange, 
  handleClickMenu, 
  items, 
  position,
  small
}) {
    const ref = useRef(null);
  
    const handleClickOutside = (event) => {
      if (ref && ref.current && !ref.current.contains(event.target)) {
        handleChange(false);
      }
    };
  
    useEffect(() => {
      document.addEventListener('click', handleClickOutside, true);
      return () => {
        document.removeEventListener('click', handleClickOutside, true);
      };
    }, []);

    const positionObject = position || {};
  
    return (
      <div className={cn(style.popupMenu, { [style.smallContainer]: small})} style={positionObject} ref={ref}>
        <ul>
          {items.map(({ key, title, icon: Icon }) => (
            <li className={cn({[style.small]: small})}key={key} role="button" onClick={() => handleClickMenu(key)}>
                <div className={style.icon}>
                    <Icon />
                </div>
              {title}
            </li>
          ))}
        </ul>
      </div>
    );
  }
  
  PopUpMenu.propTypes = {
    handleChange: PropTypes.func.isRequired,
    handleClickMenu: PropTypes.func.isRequired,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        icon: PropTypes.elementType
      }),
    ).isRequired,
    position: PropTypes.shape({
      top: PropTypes.number,
      left: PropTypes.number,
      right: PropTypes.number,
      bottom: PropTypes.number,
    }),
  };

  export default PopUpMenu;
